var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      staticClass: "eval_addreport_drawer addreportDrawer",
      attrs: {
        size: "660px",
        visible: _vm.visibleDrawer,
        "destroy-on-close": "",
        "before-close": _vm.beforeDrawClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDrawer = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _c("div", { staticClass: "addHeader-box" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("pc_gwnl_eval_import_eval_title")) +
              "\n    "
          ),
        ]),
      ]),
      _c(
        "div",
        [
          _c("TeamReportNameSet", {
            ref: "teamReportNameSet",
            attrs: { models: _vm.models, "import-methods": _vm.importMethods },
            on: { success: _vm.handleImportSuccess },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleCancel } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_global_msg_cancel")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }